export const ADD_CONTACT = "contact/add-contact";
